// Nomes das regras de usuário COMO GRAVADOS NO BANCO → rótulo exibido.
//
// ⚠️ Não renomear as regras no banco: o backend depende dos valores
// literais — o login e a criação de sócio buscam `name: 'User'`
// (auth.service/users.service). A tradução é só de exibição; o que se
// grava continua sendo o roleId.
const labels: Record<string, string> = {
  User: "Usuário",
  Admin: "Administrador",
  Developer: "Desenvolvedor",
  Manager: "Gerente",
};

export const roleLabel = (name?: string | null) =>
  (name && labels[name]) || name || "";
